import { ListingTutos } from '@components/listing-tutos/models';
import { ElasticSearchResponse, TutoDocument } from '@shared/services/elastic-search/models';

export const tutosSerializer = (response: ElasticSearchResponse<TutoDocument>): ListingTutos => ({
  tutos: response.hits.hits.map((hit) => {
    const source = hit._source;
    return {
      url: source.url?.[0] ?? '',
      image: source.image?.[0] ?? undefined!,
      text: source.body?.[0] ?? '',
      title: source.title?.[0] ?? '',
    };
  }),
});
